import React from "react";
import { Box, Typography, Grid, Divider, MenuItem } from "@mui/material";
import FormTextField from "../../../../../core/ui/FormTextField";
import TabGroup from "../../../../../core/ui/TabGroup";
import Button from "../../../../../core/ui/Button";
import { SOURCE_OPTIONS } from "../../../../../core/utility/constants";

export default function ContactInformationStep({ form, setForm, setClientModalOpen, errors = {}, handleChange }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#283745" }}>
          Existing Client?
        </Typography>
        <TabGroup
          tabLabels={["Yes", "No"]}
          activeTab={form.existingClient ? 0 : 1}
          handleTabChange={(e, newValue) => {
            setForm({ ...form, existingClient: newValue === 0 });
          }}
        />
        {form.existingClient && (
          <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
            <Button
              variant={form.selectedClient ? "muted" : "primary"}
              sx={{ height: 40, fontWeight: 600, maxWidth: "135px" }}
              onClick={() => setClientModalOpen(true)}
            >
              {form.selectedClient ? "Change" : "Select Client"}
            </Button>
            <FormTextField
              disabled
              value={
                form.selectedClient
                  ? `${
                      form.selectedClient.business_name ||
                      form.selectedClient.engaging_client_name ||
                      form.selectedClient.name ||
                      ""
                    } - ${form.clientNo || ""}`
                  : ""
              }
              placeholder="Select here..."
              maxwidth="361px"
              error={!!errors.selectedClient}
              errorMessage={errors.selectedClient}
            />
          </Box>
        )}
      </Box>
      <Divider sx={{ my: "9px" }} />
      <Grid container sx={{ maxWidth: "746px", gap: "24px" }}>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Contact Name"
            required
            value={form.contactName}
            onChange={handleChange && handleChange("contactName")}
            placeholder="Paulo Moreno"
            maxwidth="361px"
            error={!!errors.contactName}
            errorMessage={errors.contactName}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Position"
            required
            value={form.position}
            onChange={handleChange && handleChange("position")}
            placeholder="Office Staff"
            maxwidth="361px"
            error={!!errors.position}
            errorMessage={errors.position}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Contact Number"
            required
            value={form.contactNumber}
            onChange={handleChange && handleChange("contactNumber")}
            placeholder="+63 912345679"
            maxwidth="361px"
            error={!!errors.contactNumber}
            errorMessage={errors.contactNumber}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <FormTextField
            label="Email Address"
            required
            type="email"
            value={form.emailAddress}
            onChange={handleChange && handleChange("emailAddress")}
            placeholder="email@address.com"
            maxwidth="361px"
            error={!!errors.emailAddress}
            errorMessage={errors.emailAddress}
          />
        </Grid>
        <Grid item xs={12}>
          <FormTextField
            label="Address"
            required
            multiline
            rows={3}
            value={form.address}
            onChange={handleChange && handleChange("address")}
            fullWidth
            error={!!errors.address}
            errorMessage={errors.address}
          />
        </Grid>
        <Grid item xs={12}>
          <FormTextField
            label="Source"
            required
            select
            value={form.source}
            onChange={handleChange && handleChange("source")}
            maxwidth="364px"
            error={!!errors.source}
            errorMessage={errors.source}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) => {
                if (!selected) {
                  return <span style={{ color: "#999" }}>Website</span>;
                }
                return selected;
              },
            }}
          >
            {SOURCE_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </FormTextField>
        </Grid>
      </Grid>
    </Box>
  );
}
